<div
  class="sub-menu-shell"
  (mouseenter)="resetScrollbarTimer()"
  (mouseleave)="clearScrollbarTimer()"
>
  <!-- Pinned header row — stays visible regardless of scroll -->
  <div class="sub-menu-header">
    <div class="selected-module-accent" [ngClass]="currentModuleClass">
      <span class="accent-dot"></span>
      <span class="accent-text">{{ currentModuleName }}</span>
    </div>

    <div
      class="collapse-toggle cursor-pointer"
      (click)="toggleSidebarCollapse()"
    >
      <svg
        class=" "
        style="border: none"
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <g
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        >
          <path d="M15 3.5v17M11 9l-3 3l3 3" />
          <path
            d="M3 9.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 3 7.16 3 9.4 3h5.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C21 6.04 21 7.16 21 9.4v5.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C17.96 21 16.84 21 14.6 21H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 17.96 3 16.84 3 14.6z"
          />
        </g>
      </svg>
    </div>
  </div>

  <!-- Integration Hub Top Area -->
  <div
    *ngIf="currentModuleName === 'Integrations Hub' && !isSidebarCollapsed"
    class="px-3 py-3 border-b border-white/5 shrink-0"
  >
    <div class="flex items-center justify-between mb-2">
      <div
        class="text-2sm font-semibold text-gray-900 dark:text-gray-100 tracking-wider"
      >
        Total ({{ totalIntegrationsCount }})
      </div>
      <button
        type="button"
        class="toggle-all-button"
        (click)="toggleAllSections()"
      >
        {{ areAllSectionsCollapsed() ? "Expand All" : "Collapse All" }}
      </button>
    </div>
    <label
      class="input input-sm"
      [ngClass]="{ 'border border-warning': integrationSearchQuery != '' }"
    >
      <i class="ki-filled ki-magnifier"></i>
      <input
        #search
        type="text"
        placeholder="Search integrations..."
        [value]="integrationSearchQuery || ''"
        (input)="onIntegrationSearch(search.value)"
      />
      <button
        *ngIf="search.value"
        type="button"
        class="clear-btn text-xl"
        (click)="clearSearch(search)"
      >
        ×
      </button>
    </label>
  </div>

  <!-- Scrollable nav area fills remaining height -->
  <nav class="sub-menu-nav" id="sidebar_content" aria-label="Sidebar menu">
    <div class="sub-menu-scroll-zone">
      <button
        class="sub-menu-fade sub-menu-fade--up"
        [class.sub-menu-fade--visible]="canScrollUp"
        (click)="scrollUp()"
        aria-label="Scroll up"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M5 15l7-7 7 7"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>

      <div
        #scrollViewport
        class="sub-menu-scroll"
        [class.hide-scrollbar]="hideScrollbar"
        id="sidebar_scrollable"
      >
        <div
          class="sub-menu-list"
          [ngClass]="currentModuleClass"
          id="sidebar_menu"
        >
          <div
            *ngIf="
              currentModuleName === 'Integrations Hub' &&
              (integrationSearchQuery || '').trim() !== '' &&
              subMenuSections.length === 0
            "
            class="flex flex-col items-center justify-center py-10 px-4 text-center"
          >
            <i class="ki-filled ki-magnifier text-3xl text-gray-500 mb-2"></i>
            <span class="text-sm font-semibold text-gray-200 mb-1">
              No results found
            </span>
            <span class="text-xs text-gray-500 max-w-[200px]">
              We couldn't find any integrations matching "{{
                integrationSearchQuery
              }}"
            </span>
          </div>
          <ng-container
            *ngFor="
              let section of subMenuSections;
              trackBy: trackBySubMenuSection
            "
          >
            <section
              class="sub-menu-section"
              *ngIf="hasVisibleSubMenuItems(section)"
            >
              <h2
                *ngIf="
                  section.label &&
                  !(
                    currentModuleName === 'Integrations Hub' &&
                    isSidebarCollapsed
                  )
                "
                [ngClass]="
                  currentModuleName === 'Integrations Hub'
                    ? 'integration-category-header'
                    : 'sub-menu-heading transition-colors flex justify-between items-center'
                "
                [class.active]="
                  currentModuleName === 'Integrations Hub' &&
                  isCategoryActive(section)
                "
                (click)="onSidebarSectionClick(section)"
              >
                <ng-container *ngIf="currentModuleName === 'Integrations Hub'">
                  <div class="flex items-center gap-2.5 min-w-0 flex-1">
                    <span
                      class="category-icon shrink-0 flex items-center justify-center"
                      [innerHTML]="
                        getCategoryIcon(
                          section.originalCategory || section.label
                        )
                      "
                    ></span>
                    <span class="category-label">{{ section.label }}</span>
                  </div>
                  <span
                    class="chevron-icon flex items-center justify-center transition-colors shrink-0 ml-1.5"
                  >
                    <svg
                      class="w-3.5 h-3.5 transition-transform duration-200"
                      [style.transform]="
                        section.isExpanded !== false
                          ? 'rotate(90deg)'
                          : 'rotate(0deg)'
                      "
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </span>
                </ng-container>

                <ng-container *ngIf="currentModuleName !== 'Integrations Hub'">
                  <span>{{ section.label }}</span>
                </ng-container>
              </h2>

              <ng-container
                *ngIf="
                  currentModuleName !== 'Integrations Hub' ||
                  section.isExpanded !== false ||
                  isSidebarCollapsed
                "
              >
                <ng-container
                  *ngFor="
                    let config of section.items;
                    trackBy: trackBySubMenuItem
                  "
                >
                  <ng-container *ngIf="canShowSidebarItem(config)">
                    <button
                      type="button"
                      [ngClass]="
                        currentModuleName === 'Integrations Hub'
                          ? isSidebarCollapsed
                            ? 'integration-item-button-collapsed'
                            : 'integration-item-button'
                          : 'sub-menu-link group relative'
                      "
                      [class.active]="isSidebarItemActive(config)"
                      (click)="onSidebarItemClick(config, $event)"
                      (mouseenter)="onItemMouseEnter($event, config)"
                      (mouseleave)="onItemMouseLeave()"
                    >
                      <span
                        class="sub-menu-icon shrink-0"
                        [style.color]="config.color"
                      >
                        <img
                          *ngIf="isImageUrl(getIconUrl(config))"
                          [src]="getIconUrl(config)"
                          (error)="handleSidebarImageError(config, $event)"
                          class="w-full h-full object-contain rounded-xs"
                          [class.sub-menu-default-icon]="
                            getIconUrl(config) ===
                            '/assets/media/integration/default.svg'
                          "
                        />
                        <span
                          *ngIf="!isImageUrl(getIconUrl(config))"
                          [innerHTML]="getSubMenuIcon(config.icon)"
                        ></span>
                      </span>
                      <span
                        class="sub-menu-title flex-1 text-left text-sm"
                        [ngClass]="
                          currentModuleName === 'Integrations Hub'
                            ? 'font-medium text-gray-200 whitespace-normal break-words leading-tight'
                            : 'truncate'
                        "
                        [title]="config.label || config.childId"
                      >
                        {{ config.label || config.childId }}
                      </span>

                      <!-- Integration Hub Specific Right Side -->
                      <div
                        *ngIf="
                          currentModuleName === 'Integrations Hub' &&
                          !isSidebarCollapsed
                        "
                        class="flex items-center shrink-0 ml-2"
                      >
                        <div
                          class="accent-dot"
                          style="
                            background-color: #22c55e;
                            box-shadow: 0 0 8px rgba(34, 197, 94, 0.6);
                          "
                          *ngIf="config['status'] === 'Connected'"
                        ></div>
                        <div
                          class="accent-dot"
                          style="
                            background-color: #ef4444;
                            box-shadow: 0 0 8px rgba(239, 68, 68, 0.6);
                          "
                          *ngIf="
                            config['status'] === 'Failed' ||
                            config['status'] === 'failed'
                          "
                        ></div>
                        <div
                          class="rounded-full"
                          style="
                            width: 8px;
                            height: 8px;
                            background-color: #6b7280;
                          "
                          *ngIf="
                            config['status'] !== 'Connected' &&
                            config['status'] !== 'Failed' &&
                            config['status'] !== 'failed'
                          "
                        ></div>
                      </div>

                      <!-- Regular Menu Hover Edit Icon -->
                      <div
                        *ngIf="
                          currentModuleName !== 'Integrations Hub' &&
                          config['status'] === 'Connected'
                        "
                        class="flex items-center gap-2 shrink-0 ml-2"
                      >
                        <div
                          class="w-1.5 h-1.5 rounded-full bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.6)]"
                        ></div>
                      </div>
                    </button>
                  </ng-container>
                </ng-container>
              </ng-container>
            </section>
          </ng-container>
        </div>
      </div>

      <button
        class="sub-menu-fade sub-menu-fade--down"
        [class.sub-menu-fade--visible]="canScrollDown"
        (click)="scrollDown()"
        aria-label="Scroll down"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M19 9l-7 7-7-7"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </nav>

  <!-- Global tooltip for collapsed sidebar -->
  <div
    *ngIf="isSidebarCollapsed && hoveredItem"
    class="sub-menu-tooltip"
    [style.top.px]="tooltipTop"
    [style.left.px]="tooltipLeft"
  >
    {{ hoveredItem.label || hoveredItem.childId }}
  </div>
</div>
